export { default } from './EventsUserNoticeService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/services/EventsUserNoticeService/index.js